function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { $unibase } from '../uni-base-module';
var perdidaSesionFailMsg = '                                                ' + 'IMPORTANTE\n                                                -----------------\n\n' + 'Ha habido un problema con la aplicación relativo a la sesión actual, y se ha intentado recuperar, ' + 'pero también ha habido algún problema en el proceso.\n\n' + 'Seguramente deberás volver a cargar la página o volver a entrar a la sección donde te encuentras.\n\n' + 'Los datos que no hayas podido guardar se van a perder, desgraciadamente no podemos hacer mucho ahí.\n\n' + 'Si crees que esto te pasa a menudo, por favor déjanos una incidencia, incluso nos vendría bien una incidencia en este caso. Gracias!';
var perdidaSesionFailReloginMsg = '                                                ' + 'IMPORTANTE\n                                                -----------------\n\n' + 'Ha habido un problema con la aplicación relativo a la sesión actual, y se ha intentado recuperar, ' + 'pero también ha habido algún problema en el proceso.\n\n' + 'Seguramente deberás volver a cargar la página o volver a entrar a la sección donde te encuentras.\n\n' + 'Los datos que no hayas podido guardar se van a perder, desgraciadamente no podemos hacer mucho ahí.\n\n' + 'Si crees que esto te pasa a menudo, por favor déjanos una incidencia, incluso nos vendría bien una incidencia en este caso. Gracias!';
var perdidaSesionOkMsg = 'Ha habido un problema con la aplicación al realizar la última acción ' + "pero en principio se ha podido recuperar correctamente (nosotros le llamamos a esto 'pérdida de sesión').\n\n" + 'Sin embargo, tendrás que volver a realizar la última acción. Si te vuelve a aparecer el mensaje es que hay algún problema más, ' + 'por favor déjanos una incidencia.\n\n' + 'Un posible caso de este error es que hayas estado tiempo (pero mucho!) sin cambiar de pantalla o trabajando en esta pantalla sin guardar datos. ' + 'Si este no es el caso, o este mensaje te aparece a menudo (varias veces a la semana por ejemplo) déjanos también una incidencia. Gracias!';

// ErrorServicio.MsgApi

export var NotificacionService = /*#__PURE__*/function () {
  NotificacionService.$inject = ["$log", "$q", "$http", "$window", "$timeout", "toastr", "$animate"];
  function NotificacionService($log, $q, $http, $window, $timeout, toastr, $animate) {
    var _this = this;
    _classCallCheck(this, NotificacionService);
    _defineProperty(this, "URL_RELOGIN", null);
    this.$log = $log;
    this.$q = $q;
    this.$http = $http;
    this.$window = $window;
    this.$timeout = $timeout;
    this.toastr = toastr;
    this.$animate = $animate;
    this.CHECK_API_URL = '/xxxxxxxxxxxx/services/rest/priv/auth/check';
    this._global_loading = null;

    // jsc : 20171110 : asociar el servicio al window para testing
    if (!$window.uniNotfService) $window.uniNotfService = this;
    this.loading = {
      show: function show(msg, title, options) {
        _this._global_loading = _this.toastr.info(msg, title, options);
        _this.$animate.enabled(_this._global_loading.el, false);
        return _this._global_loading;
      },
      clear: function clear() {
        _this._global_loading && _this.toastr.clear(_this._global_loading);
        _this._global_loading = null;
      },
      start: function start(msg, _title, options) {
        var action = new LoadingAction(msg, options);
        _this._global_loading = action._itoast;
        return action;
      },
      /* aviso: (msg: string, title?: string, options?: ng.toastr.IToastOptions) => {
                          let action = new LoadingAction(msg)
                          this._global_loading = action._itoast
                      }, */
      action: function action(msgLoading, msgOk, cb) {
        // tsvar info = this.loading.start(msgLoading)
        var info = _this.loading.start(msgLoading, null, {
          timeOut: 30000
        });

        // generar un defer a partir del resultado si es una función
        var $p = cb instanceof Function ? $q.when(cb()) : cb;
        $p.then(function () {
          if (msgOk) {
            _this.good(msgOk);
            _this._trace('>>' + msgOk);
          }
        }, function (err) {
          $log.info('NotifService: loading gestionando error ', err);
          _this.aviso('Error en la aplicación');
        })["finally"](function () {
          info.clear();
        });
        return $p;
      }
    };
    this.spinner = {
      active: false,
      msg: 'aaaa',
      on: function on(msg) {
        if (msg) _this.spinner.msg = msg;
        _this.spinner.active = true;
      },
      off: function off() {
        _this.spinner.active = false;
      },
      start: function start(msg) {
        return new SpinnerAction(msg);
      },
      action: function action(msg1, cb) {
        var info = _this.spinner.start(msg1);

        // generar un defer a partir del resultado si es una función
        var $p = cb instanceof Function ? $q.when(cb()) : cb;
        $p["catch"](function (errr) {
          $log.info('NotifService: spinner action gestionando error ', errr);
        })["finally"](function () {
          _this.spinner.off();
          info.off();
        });
        return $p;
      },
      loading: function loading(msgLoading, msgOk, $p) {
        _this.loading.action(msgLoading, msgOk, $p);
        _this.spinner.start('');
        $p["catch"](function (errr) {
          $log.info('NotifService: spinner loading gestionando error ', errr);
        })["finally"](function () {
          _this.spinner.off();
        });
        return $p;
      }
    };
    var _notifService = this;
    var SpinnerAction = /*#__PURE__*/function () {
      function SpinnerAction(msg) {
        _classCallCheck(this, SpinnerAction);
        _defineProperty(this, "error", function () {
          var args = arguments;
          _notifService.$timeout(function () {
            _notifService.spinner.off();
            _notifService.error(args[0], args[1], args[2]);
          });
        });
        _notifService.spinner.on(msg);
      }
      return _createClass(SpinnerAction, [{
        key: "good",
        value: function good() {
          _notifService.$timeout(function () {
            _notifService.spinner.off();
            _notifService._trace('>> spinner off');
          });
        }
      }, {
        key: "aviso",
        value: function aviso(msg, title, options) {
          _notifService.$timeout(function () {
            _notifService.spinner.off();
            _notifService.aviso(msg, title, options);
            _notifService._trace('>> spinner off');
          });
        }
      }, {
        key: "off",
        value: function off() {
          this.good();
        }
      }]);
    }();
    var LoadingAction = /*#__PURE__*/function () {
      function LoadingAction(msg, options) {
        _classCallCheck(this, LoadingAction);
        this._itoast = _notifService.loading.show(msg, undefined, options);
      }
      return _createClass(LoadingAction, [{
        key: "good",
        value: function good(msg, title, options) {
          toastr.clear(this._itoast);
          $timeout(function () {
            _notifService.good(msg);
            _notifService._trace('>> ', msg);
          }, 20);
        }
      }, {
        key: "goood",
        value: function goood(msg, title, options) {
          toastr.clear(this._itoast);
          $timeout(function () {
            _notifService.goood(msg);
            _notifService._trace('>> ', msg);
          }, 0);
        }
      }, {
        key: "aviso",
        value: function aviso(msg, title, options) {
          toastr.clear(this._itoast);
          $timeout(function () {
            _notifService.aviso(msg);
            _notifService._trace('>> ', msg);
          }, 20);
        }
      }, {
        key: "warning",
        value: function warning(msg, title, options) {
          toastr.warning(msg, title, options);
        }
      }, {
        key: "clear",
        value: function clear() {
          toastr.clear(this._itoast);
        }
      }, {
        key: "error",
        value: function error() {
          toastr.clear(this._itoast);
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          _notifService.error(args[0], args[1], args[2]);
        }
      }]);
    }();
  }
  return _createClass(NotificacionService, [{
    key: "_trace",
    value: function _trace(arg0) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      this.trace && this._debug(arg0, args);
    }
  }, {
    key: "_debug",
    value: function _debug(arg0) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }
      this.$log.debug('::' + arg0, args);
    }
  }, {
    key: "extraeStatus",
    value: function extraeStatus(errorArgs) {
      this.$log.debug('=== Status error', errorArgs);
      if (errorArgs && errorArgs.length > 2) {
        // el status es el segundo ??
        if (typeof errorArgs[1] == 'number') {
          return errorArgs[1];
        }
      }

      // undefined
    }
  }, {
    key: "__legacyAlert",
    value: function __legacyAlert(msg) {
      // informar de un caso legacy,
      if (msg instanceof Object) {
        this._debug('********* \n\n     usando un alert sin gestionar el mensaje <<-- necesita gestión ', msg);
        try {
          console.trace();
        } catch (e) {}
      }
      window.alert('\n*********\n\n' + msg + '\n\n\n*********');
      this._trace('** ' + msg + '**');
    }
  }, {
    key: "gestionaPerdidaSesion",
    value: function gestionaPerdidaSesion(status, errorArgs) {
      var _this2 = this;
      // gestionar un 410 o un 401
      if (410 === status || 401 === status) {
        // se ha perdido la sesión, intentar reiniciar la sesión
        this.relogin(true).then(function () {
          // ha ido ok
          _this2.__legacyAlert(perdidaSesionOkMsg);
        }, function (error) {
          _this2.__legacyAlert(_this2.URL_RELOGIN ? perdidaSesionFailReloginMsg : perdidaSesionFailMsg);
          if (_this2.URL_RELOGIN) {
            var w = window.open(_this2.URL_RELOGIN);
            if (!w) {
              console.log('No se puede abrir la ventana login');
              $('body').addClass('__sinsesion__');
            }
          }
        });
        return true;
      }
      return false;
    }
  }, {
    key: "extraMsgApi",
    value: function extraMsgApi(responseData) {
      if (responseData.__v === '001') return responseData.msg;
      if (responseData.__v === '002') return responseData.msg + (responseData.detail ? ' : ' + responseData.detail : '');
      this.$log.error('Api desconocida: ' + responseData.__v, responseData);
      return '*';
    }

    /* ex spring es
             {
                "error": "Internal Server Error",
                "exception": "org.springframework.orm.ObjectRetrievalFailureException",
                "message": "No row with the given identifier exists: [#232791]; nested exception is org.hibernate.ObjectNotFoundException: No row with the given identifier exists: [#232791]",
                "path": "/unitec/api/er/em/232791",
                "status": 500,
                "timestamp": 1510146635439
            }
            */
  }, {
    key: "enhanceExcepcionSpring",
    value: function enhanceExcepcionSpring(responseData) {
      return responseData.message || responseData.error;
    }

    // errorArgs es [ data, status, headers, config ]

    /* ex ErrorServicio es
             {
                "__v": "002",
                "detail": "Sector no encontrado en el catálogo buscando 'OFICINAS - DESPACHOS'",
                "msg": "Error en la aplicación"
            }
             */

    /** Este método debe devolver si se ha gestionado el error */
  }, {
    key: "notificaErrorServicios",
    value: function notificaErrorServicios(deferred, errorArgs, msg) {
      var _this3 = this;
      var status = this.extraeStatus(errorArgs);
      this.$log.info('status error', status);

      // si hay pérdida de sesión, ya se ha informado del error
      if (this.gestionaPerdidaSesion(status, errorArgs)) return this.$q.when(true);
      if (errorArgs && errorArgs.length) {
        // puede ser un arguments, tiene más de 1 elemento

        // si el responseType es blob, al fallar seguirá siendo Blob
        return this.dataDesdeJson(errorArgs[0]).then(function (responseData) {
          if (responseData && responseData.__v) {
            msg = msg + ':\n\n' + _this3.extraMsgApi(responseData);
          } else if (responseData && responseData.mensaje) {
            msg = msg + ':\n\n' + responseData.mensaje;
          } else if (responseData && responseData.timestamp && responseData.exception) {
            // ResponseEntityHandler

            _this3.$log.error('Ex HttpResponse', responseData);

            // mensaje excepción Spring
            msg = msg + ':\n\n' + _this3.enhanceExcepcionSpring(responseData);
          } else if (errorArgs.length > 1) {
            // caso especial un HttpEntity
            if (417 === status && responseData.statusText) {
              // es un acceso denegado
              msg = msg + ':\n\n' + responseData.statusText;
            }

            // no hay mensaje, caso especial
            if (403 === status) {
              // es un acceso denegado
              msg = msg + ':\n\n' + '*** Acceso denegado para esta operación **** \n\nVuelva a recargar la página para volver a introducir las credenciales de entrada';
            }
          }

          // mostrar el mensaje de error
          _this3.mostrarMensajeError(msg);

          // se ha gestionado
          return _this3.$q.when(true);
        })["catch"](function () {
          // error al obtener los datos de respuesta

          // error al gestionar
          _this3.mostrarMensajeError(msg);

          // no se ha gestionado
          return _this3.$q.when(false);
        });
      }

      // si no se ha gestionado mostrar mensaje error
      this.mostrarMensajeError(msg);

      // se ha gestionado siempre???
      return this.$q.when(true);
    }
  }, {
    key: "mostrarMensajeError",
    value: function mostrarMensajeError(msg) {
      var _this4 = this;
      this.$log.error('>> (Error)', msg);

      // si hay un loading, limpiar mensaje
      this._global_loading && this.loading.clear();
      this.$timeout(function () {
        _this4.__legacyAlert(msg);
      });
    }

    /** si es Blob, intenta convertir desde Json, si no lo devuelve, asume que ya es objeto */
  }, {
    key: "dataDesdeJson",
    value: function dataDesdeJson(dataOrBlob) {
      return dataOrBlob instanceof Blob ? this.blobToJson(dataOrBlob) : this.$q.when(dataOrBlob);
    }
  }, {
    key: "blobToJson",
    value: function blobToJson(blob) {
      var defer = this.$q.defer();
      var fr = new FileReader();
      var reader = new FileReader();
      reader.onloadend = function () {
        return defer.resolve(angular.fromJson(reader.result));
      };
      reader.onerror = function () {
        return defer.reject({
          message: 'La respuesta no es correcta'
        });
      };
      reader.readAsText(blob);
      return defer.promise;
    }
  }, {
    key: "random",
    value: function random() {
      return this.randomInternal(0);
    }
  }, {
    key: "randomInternal",
    value: function randomInternal(i) {
      var r = (Math.random() * Math.random()).toString(36);
      if (r.length < 4) return i > 2 && '*****' || this.randomInternal(i + 1);else return r.substr(7);
    }
  }, {
    key: "checkPOST",
    value: function checkPOST(witness) {
      return this.$http.post(this.CHECK_API_URL, {
        witness: witness
      }, {
        withCredentials: true
      });
    }
  }, {
    key: "relogin",
    value: function relogin(checkWithPOST) {
      var _this5 = this;
      var defer = this.$q.defer();
      var witness = this.random();
      this.$log.info(witness);

      // realizar un get para forzar la sesión
      this.$http.get("".concat(this.CHECK_API_URL, "?witness=").concat(witness), {
        withCredentials: true
      }).then(function (payload) {
        // comprobar el witness y que tiene usuario

        // si se pide reconfirmación por POST
        if (checkWithPOST) {
          // recomprobar con un post
          _this5.checkPOST(witness).then(function (payloadPOST) {
            // reautenticación correcta

            defer.resolve();
          }, function (error) {
            // error al reautenticar la sesión
            _this5.$log.error('Error al reautenticar', error);
            defer.reject(error);
          });
        } else defer.resolve();
      }, function (error) {
        _this5.$log.error('Error al regenerar la sesión', error);
        defer.reject(error);
      });
      return defer.promise;
    }
  }, {
    key: "setCheckUrl",
    value: function setCheckUrl(u) {
      this.CHECK_API_URL = u;
    }
  }, {
    key: "setUrlRelogin",
    value: function setUrlRelogin(url) {
      this.URL_RELOGIN = url;
    }
  }, {
    key: "alert",
    value: function alert(msg) {
      this.__legacyAlert(msg);
    }
  }, {
    key: "error",
    value: function error(deferred, errorArgs, msg) {
      return this.notificaErrorServicios(deferred, errorArgs, msg);
    }
  }, {
    key: "errorMsg",
    value: function errorMsg(msg, title) {
      return this.error(null, null, (title && title + '\n\n\n' || '') + (msg || '(sin información al respecto)'));
    }
  }, {
    key: "error1",
    value: function error1() {} // ??????
  }, {
    key: "info",
    value: function info(msg, title, options) {
      this.toastr.info(msg, title, options);
      this._trace('>> ', msg, title, options);
    }
  }, {
    key: "aviso",
    value: function aviso(msg, title, options) {
      this.toastr.warning(msg || '', title, options);
    }
  }, {
    key: "good",
    value: function good(msg, title, options) {
      this.toastr.success(msg, title, options || {
        timeOut: 350
      });
      this._trace('>>', msg, title, options);
    }
  }, {
    key: "goood",
    value: function goood(msg, title, options) {
      var t = this.toastr.success(msg, title, options || {
        timeOut: 350
      });
      this.$animate.enabled(t.el, false);
      this._trace('>>', msg, title, options);
    }
  }, {
    key: "testError",
    value: function testError(msg) {
      var _this6 = this;
      this.$timeout(function () {
        _this6.$log.info('testError en $timeout');
        throw new Error(msg);
      }, 100);
      throw new Error(msg);
    }
  }]);
}();
$unibase.service('NotifService', NotificacionService);